export default __webpack_public_path__ + "static/media/landing-notbook-cronos.d8bb3c21.jpg";